import React from 'react';
import IAMContext from '../Context';

const useIAM = contextFunc => {
  return React.useContext(IAMContext).IAMAuthorizer({}, contextFunc);
};

export default useIAM;
